import './scroll-on-drag.less';

import { stopEvent } from '../../utils/event-utils';

export const scrollOnDragDirectiveModule = angular
  .module('Q.components.scroll-on-drag', [])

  // Note: this directive is not designed to work on window/body, it only works on dom nodes
  .directive('scrollOnDrag', function ($document) {
    return {
      restrict: 'A',
      link: function (scope, el, attr) {
        let startXPos;
        let startYPos;
        let scrollXPos;
        let scrollYPos;
        let curDown = false;
        let enabled = false;

        function stopDrag() {
          // safe-to-call method to stop dragging whenever we want
          el.removeClass('scroll-on-drag-active');
          curDown = false;
          $document.off('mouseup', stopDrag);
          $document.off('mousemove', mouseMoveListener);
        }

        function mouseDownListener(e) {
          if (enabled) {
            stopEvent(e);
            el.addClass('scroll-on-drag-active');
            curDown = true;
            // store initial values
            startXPos = e.pageX;
            startYPos = e.pageY;
            scrollXPos = el[0].scrollLeft;
            scrollYPos = el[0].scrollTop;

            // start listening to document-level movement, so we can track outside the element
            $document.on('mouseup', stopDrag);
            $document.on('mousemove', mouseMoveListener);
          }
        }

        function mouseMoveListener(e) {
          if (enabled && curDown === true) {
            stopEvent(e);
            el[0].scrollLeft = scrollXPos + startXPos - e.pageX;
            el[0].scrollTop = scrollYPos + startYPos - e.pageY;
          }
        }

        checkEnable();

        // if we only need a link function, use this
        scope.$watch(attr.scrollOnDrag, checkEnable);

        function checkEnable() {
          if (attr.scrollOnDrag && scope.$eval(attr.scrollOnDrag) === false) {
            disable();
          } else {
            enable();
          }
        }

        function enable() {
          if (!enabled) {
            stopDrag();
            el.on('mousedown', mouseDownListener);
            el.addClass('scroll-on-drag-enabled');
            enabled = true;
          }
        }

        function disable() {
          if (enabled) {
            stopDrag();
            el.off('mousedown', mouseDownListener);
            el.removeClass('scroll-on-drag-enabled');
            enabled = false;
          }
        }
      },
    };
  });
